module.exports = "//a.spikex.com/sigma/frontend-ssr-web-index/_next/static/images/moneyBox-8d621762c64eefaaf11b73176a09dc69.png";